module.exports = __webpack_public_path__ + "static/q6answer2_rustic_wishmas-73a4cdd2da88382179a3e391df34fbab.jpg";